module.exports = function() {
  return new Worker(__webpack_public_path__ + "bd6757fb100b49cc0c71.worker.js");
};